import { useOnboardingContext } from "onboarding/OnboardingContext";
import { Text } from "@ttc3k/trekker";
import { VideoIcon } from "onboarding/components";
import { useEffect } from "react";
import { styled } from "styled-system/jsx";
import { useTranslation } from "react-i18next";
import { getMultilingualString } from "shared/utils";

export const WelcomeScreen = () => {
  const { t } = useTranslation("onboarding", { keyPrefix: "WELCOME_SCREEN" });
  const { organization } = useOnboardingContext();

  useEffect(() => {
    function loadWistia() {
      const videoScript = document.createElement("script");
      videoScript.async = true;
      videoScript.src = `https://fast.wistia.com/embed/medias/${organization?.onboardingMetadata.videoId}.jsonp`;
      document.head.appendChild(videoScript);
      const wistiaScript = document.createElement("script");
      wistiaScript.async = true;
      wistiaScript.src = "https://fast.wistia.com/assets/external/E-v1.js";
      document.head.appendChild(wistiaScript);
    }
    loadWistia();
  }, [organization?.onboardingMetadata.videoId]);

  return (
    <>
      {organization?.onboardingMetadata.videoId && (
        <styled.span
          className={`wistia_embed wistia_async_${organization?.onboardingMetadata.videoId} popover=true popoverContent=link videoFoam=false`}
          display={"inline"}
          position={"relative"}
          cursor={"pointer"}
          mb={"500"}
        >
          <VideoIcon />
        </styled.span>
      )}
      <Text color={"text.mid"} textAlign={"center"}>
        {organization?.onboardingMetadata.introMessage ??
          t("FALLBACK_DESCRIPTION", {
            organizationName: getMultilingualString(organization?.name ?? {}),
          })}
      </Text>
    </>
  );
};
